import { createRouter, RouterProvider } from '@tanstack/react-router';
import { Suspense } from 'react';
import { CarregandoSistema } from './CarregandoSistema';
import { DefaultErrorComponent } from './DefaultErrorComponent';
import { NotFoundPage } from './NotFoundPage';
import { oldRoutesCompat } from './old-routes-compat/old-routes-compat';
import { routeTree } from './routeTree.gen';

export const router = createRouter({
    defaultErrorComponent: DefaultErrorComponent,
    defaultNotFoundComponent: NotFoundPage,
    defaultPreload: 'intent',
    rewrite: {
        input: ({ url }) => oldRoutesCompat(url),
    },
    routeTree,
});

declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router;
    }
}

export function Router() {
    return (
        <Suspense fallback={<CarregandoSistema />}>
            <RouterProvider router={router} />
        </Suspense>
    );
}
